import React from 'react';

import {
  expandSidebarBlogsList as expand,
  collapseSidebarBlogsList as collapse
} from 'RLX/State/Ui/Sidebar/SidebarActions';
import { addNewBlog } from 'RLX/State/Content/ContentActions';

import Icon from 'Core/Components/Icon';

function BlogsMenu ({ siteData, ui } = {}) {
  const { blogs } = siteData;
  const collapsed = ui.sidebar.blogsListCollapsed;

  const blogLinks = collapsed ? [] : blogs.map(blog => ({
    text: <b>{blog.id}</b>,
    url: '/RLX/dash/blogs/' + blog.id,
    icon: 'book'
  }));

  return [
    {
      text: 'BLOGS',
      className: 'heading' + (collapsed ? ' collapsed' : ''),
      onClick: collapsed ? expand : collapse,
      icon: collapsed ? 'caret-left' : 'caret-down'
    },
    ...blogLinks,
    {
      text: (
        <button onClick={addNewBlog}>
          Add a Blog
          <Icon fa="plus right" />
        </button>
      )
    }
  ];
};

export default BlogsMenu;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Config/Menus/BlogsMenu.jsx